<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("voucher") }} {{ $t("codes") }}</div>
        <div class="section-subTitle my-2"
          >{{ $t("view") }} {{ $t("all") }} {{ $t("voucher") }}
          {{ $t("codes") }}</div
        >
      </div>

      <div class="d-flex">
        <div>
          <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
          <router-link class="btn-blue" to="vouchers"
            >{{ $t("voucher") }} {{ $tc("list", 2) }}</router-link
          >
        </div>

        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <div
          v-if="vocuerList && vocuerList.length > 0"
          class="d-flex justify-content-end mt-2"
        >
          <div>{{ $t("download") }} as:</div>
          <!-- :href="BASE_URL + vocuerListCSV" @click="getVoucherList((isExcel = 'Y'))"-->
          <a
            v-if="vocuerList.length > 0"
            @click="getVoucherList('Y')"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>{{ $t("voucher") }}</th>
            <th>{{ $t("voucher") }} {{ $t("code") }}</th>
            <th>{{ $t("voucher") }} {{ $t("Redeemed") }}</th>
            <th>{{ $t("voucher") }} {{ $t("Expired At") }}</th>
            <!-- <th class="text-right">
              <span class="pr-4">{{ $tc('status', 2)}}</span>
            </th>-->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(voucherItem, voucherIndex) in vocuerList"
            :key="voucherIndex"
            class="light_grey_back"
          >
            <td>{{ voucherItem.voucher_title }}</td>
            <td>{{ voucherItem.voucher_code }}</td>
            <td class="text-center">{{
              voucherItem.voucher_transaction_count
            }}</td>
            <td v-if="voucherItem.voucher_end_date_time">{{
              voucherItem.voucher_end_date_time
            }}</td>
            <td v-else>-</td>
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <label class="ios-switch">
                  <input
                    :checked="voucherItem.voucher_is_active === 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />

                  <span class="switch-slider"></span>
                </label>
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="cinema_manager_add_edit_disabled != 3"
                    v-on:click="onEditVoucher(voucherItem)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewVoucher(voucherItem)">
                    <span class="icon-eye"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click.prevent.stop="onViewVoucherUsage(voucherItem)">
                    <span class="icon-eye mr-1"></span>
                    {{ $t('view') }} {{ $t('usage') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>-->
          </tr>
        </tbody>
      </table>

      <b-pagination
        v-if="vocuerList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
  <!-- GRID VIEW -->

  <!-- LIST VIEW DESIGNATION -->
</template>

<script>
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      vocuerList: [],

      voucher_title: null,

      gridView: false,
      listView: true,
      vocuerListCSV: null,
      excelPath: "",
    };
  },
  mounted() {
    this.voucher_title = this.$route.query.voucher_title;
    if (this.voucher_title) {
      this.getVoucherList();
      this.getVoucherListCSV();
    } else {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.cinema_manager_add_edit_disabled = this.secureStore.get(
      "USINFO"
    ).role_id;
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getVoucherList();
      } else {
        this.currentPage = event;
        this.getVoucherList();
      }
    },
    getVoucherList: function(isExcel = "N") {
      let payload = {
        isExcel: "Y",
        user_name: this.secureStore.get("USINFO").username,
        cinema_id: this.secureStore.get("USINFO").cinema_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        voucher_title: this.voucher_title,
      };
      MarketingService.GetVouchersCodes(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.vocuerList = data.Records;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } 
              else {
                if(data.totalRows){
  this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
                }
              
              }
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },

    getVoucherListCSV: function() {
      MarketingService.GetSingleVoucherListCSV({
        voucher_title: this.voucher_title,
        exportType: "csv",
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.vocuerListCSV = data.FinalExcelFile;
            // if (data.Records.length > 0) {
            //   this.vocuerListCSV = data.Records;
            // }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    /* eslint-disable */
    onEditVoucher: function({ voucher_id }) {
      this.$router.push({
        path: "/marketing/edit-vouchers",
        query: { voucher_id },
      });
    },
    onViewVoucher: function({ voucher_id }) {
      this.$router.push({
        path: "/marketing/view-vouchers",
        query: { voucher_id },
      });
    },
    onViewVoucherUsage: function({ voucher_id }) {
      this.$router.push({
        path: "/marketing/view-usage-voucher",
        query: { voucher_id },
      });
    },
    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/viewVoucherCodes.vue